import {
  Cents__toString_impl_ko5hxm1a9pwstsznn43 as Cents__toString_impl_ko5hxm,
  Cents__hashCode_impl_slsn8n2ym5pwri0ohtt as Cents__hashCode_impl_slsn8n,
  _Cents___init__impl__6gjhxu21pac6t02ivb3 as _Cents___init__impl__6gjhxu,
} from '../../../../../../service-abstractions-currency/com/lightningkite/services/data/Cents.mjs';
import {
  toString1pkumu07cwy4m as toString,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  SingleChildDayfsi906tc8dp6 as SingleChildDay,
  EmployerAccountTransaction2xx9wct21t09o as EmployerAccountTransaction,
  Companion_instance3rsay32qgy1xl as Companion_instance,
  GrantAccountTransaction19one3d48lc6r as GrantAccountTransaction,
  Companion_instance1d8b451omsiul as Companion_instance_0,
  BilledDayTotals2enuwcjtkow7 as BilledDayTotals,
  PayerTotal162ou2gf96d2t as PayerTotal,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/money.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual2mm942ha7plg6 as serializerOrContextual } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SerializationHelpers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { DataClassPathSelf18kqeagzkbefr as DataClassPathSelf } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/DataClassPath.mjs';
import {
  get_voided2matvha0tyhkf as get_voided,
  get_forDate3tzeotrzulxwz as get_forDate,
  get_voided7vuonke86m7o as get_voided_0,
  get_at3sb6rh0fwrxhw as get_at,
  get_employergdu8c3bkfw8 as get_employer,
  get_voided32ny3m7cav2w3 as get_voided_1,
  get_at2gqzbsr4s5j1f as get_at_0,
  get_grant3rlqon2bl3pn7 as get_grant,
  get_name3gijmx3xstqlj as get_name,
  get_name2gnjdlpbm0se5 as get_name_0,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/ModelFields-372156621.mjs';
import {
  eq353yrgcpovoi1 as eq,
  gte1zw995v5ulf70 as gte,
  lte2qmhlnwrclg8p as lte,
  lt30kf68e33bhtj as lt,
} from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/ConditionBuilder.mjs';
import {
  await1xlt6i5aa076q as await_0,
  await1uwe8zvsjq69o as await_1,
} from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { And1a3dbpwh0hxmu as And } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Condition.mjs';
import { listOfNotNull2woi2boe01ub4 as listOfNotNull } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { Aggregate_Sum_getInstance1dnbxkj64thbo as Aggregate_Sum_getInstance } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Aggregate.mjs';
import { DataClassPathSerializer2aqs8pcwb13zn as DataClassPathSerializer } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/DataClassPathSerializer.mjs';
import { GroupAggregateQuery38kwelc2aunpz as GroupAggregateQuery } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/GroupCountQuery.mjs';
import { SortBuilder36qqny2jtmmgx as SortBuilder } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SortBuilder.mjs';
import {
  Employer27b20p5x27kte as Employer,
  Grant2zfdfpt9q1mly as Grant,
  ID__toString_impl_y5caka2oopvpysxo85x as ID__toString_impl_y5caka,
  IDqqik72jjbpsn as ID,
  ID__toString_impl_y5cakawnw120meic4d as ID__toString_impl_y5caka_0,
  ID1lyj7m2ox8cp5 as ID_0,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/domain.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Queryam9ckqg1rxkb as Query } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Query.mjs';
import { EmployerTransactionsPageanwqvpujplg1 as EmployerTransactionsPage } from '../employers/EmployerTransactionsPage.mjs';
import { GrantTransactionsPage3anbgmpp83vih as GrantTransactionsPage } from '../grants/GrantTransactionsPage.mjs';
import { get_currentSessionNotNull30vuua77prq38 as get_currentSessionNotNull } from '../../sdk/currentSession.mjs';
import { get_TCG_TIME_ZONEb89pisv39t5w as get_TCG_TIME_ZONE } from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/clock.mjs';
import { atStartOfDayInq85k5urxn794 as atStartOfDayIn } from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/TimeZone.mjs';
import { DatePeriod2y4m7pf19ebgd as DatePeriod } from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/DateTimePeriod.mjs';
import { plus1oi9f9vif99u2 as plus } from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/LocalDate.mjs';
import { asyncz02dsa2nb2zt as async } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { roundToLong2s902lrwaad4n as roundToLong } from '../../../../../../kotlin-kotlin-stdlib/kotlin/math/math.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { coroutineScope2qhrb6lhutwsn as coroutineScope } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import {
  Companion_instance1lm8x0jadqh2g as Companion_instance_1,
  Platform_Web_getInstance2840w5bkfolz8 as Platform_Web_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/Platform.mjs';
import { get_current2r182tjucmm5v as get_current } from '../../../../../../kiteui-library/com/lightningkite/kiteui/Platform.js.mjs';
import {
  Signal1973xs1vkmdcb as Signal,
  _Constant___init__impl__v45mub2qfk15kh5l39c as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
} from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { get_scrolling3fwkltztkpfe8 as get_scrolling } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { maxWidth22r11xnm7d4h4 as maxWidth } from '../components/view-utilities.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import {
  ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement,
  Companion_getInstanceztgx4sy4wjnt as Companion_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import {
  h12aidul0n4qlwh as h1,
  subtext2yjmf1ok7kb40 as subtext,
  h2ld0l0a2c9zpb as h2,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/shortcuts.mjs';
import {
  weight31wqab1913ly4 as weight,
  shownWhen3t7othivfr11 as shownWhen,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { LabeledViewseav57tyecmf as LabeledView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/labels.mjs';
import { FieldSemantic_getInstancer1p3l15xmphu as FieldSemantic_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { themed2vu67ornd4jps as themed } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { LocalDateField1854369auhx0q as LocalDateField } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LocalDateTimeField.commonHtml.mjs';
import { rememberSuspending14xvgr29y3z54 as rememberSuspending } from '../../../../../../reactive/com/lightningkite/reactive/core/RememberSuspending.mjs';
import {
  Companion_instance35wmauq2koet0 as Companion_instance_2,
  table1wgqnzrzsmc0y as table,
} from '../components/table.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { Page1o437w9xuocrm as Page } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var RowClass;
function Row() {
  if (RowClass === VOID) {
    class $ {
      constructor(name, transactions, used, ledger) {
        this.name_1 = name;
        this.transactions_1 = transactions;
        this.used_1 = used;
        this.ledger_1 = ledger;
      }
      toString() {
        return 'Row(name=' + this.name_1 + ', transactions=' + Cents__toString_impl_ko5hxm(this.transactions_1) + ', used=' + this.used_1.toString() + ', ledger=' + toString(this.ledger_1) + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.name_1);
        result = imul(result, 31) + Cents__hashCode_impl_slsn8n(this.transactions_1) | 0;
        result = imul(result, 31) + this.used_1.hashCode() | 0;
        result = imul(result, 31) + hashCode(this.ledger_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Row()))
          return false;
        if (!(this.name_1 === other.name_1))
          return false;
        if (!(this.transactions_1 === other.transactions_1))
          return false;
        if (!this.used_1.equals(other.used_1))
          return false;
        if (!equals(this.ledger_1, other.ledger_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Row');
    RowClass = $;
  }
  return RowClass;
}
function BalanceSheetPage$render$slambda$slambda$slambda($api, this$0) {
  return constructCallableReference(($this$async, $completion) => orPromise($completion, function *($completion) {
    var tmp = $api.get_singleChildDay_52scz3_k$();
    // Inline function 'com.lightningkite.services.database.condition' call
    // Inline function 'com.lightningkite.services.database.path' call
    // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
    var tmp_0 = serializerOrContextual(createKType(getKClass(SingleChildDay()), arrayOf([]), false));
    var tmp$ret$2 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
    // Inline function 'kotlin.let' call
    var it = new (DataClassPathSelf())(tmp$ret$2);
    var tmp_1 = eq(get_voided(it), null);
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = this$0.start_1;
    var tmp0_safe_receiver = yield* await_0(this_0, $completion);
    var tmp_2;
    if (tmp0_safe_receiver == null) {
      tmp_2 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'com.lightningkite.services.database.condition' call
      // Inline function 'com.lightningkite.services.database.path' call
      // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
      var tmp_3 = serializerOrContextual(createKType(getKClass(SingleChildDay()), arrayOf([]), false));
      var tmp$ret$10 = isInterface(tmp_3, KSerializer()) ? tmp_3 : THROW_CCE();
      // Inline function 'kotlin.let' call
      var it_0 = new (DataClassPathSelf())(tmp$ret$10);
      tmp_2 = gte(get_forDate(it_0), tmp0_safe_receiver);
    }
    var tmp_4 = tmp_2;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = this$0.endInclusive_1;
    var tmp1_safe_receiver = yield* await_0(this_1, $completion);
    var tmp_5;
    if (tmp1_safe_receiver == null) {
      tmp_5 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'com.lightningkite.services.database.condition' call
      // Inline function 'com.lightningkite.services.database.path' call
      // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
      var tmp_6 = serializerOrContextual(createKType(getKClass(SingleChildDay()), arrayOf([]), false));
      var tmp$ret$18 = isInterface(tmp_6, KSerializer()) ? tmp_6 : THROW_CCE();
      // Inline function 'kotlin.let' call
      var it_1 = new (DataClassPathSelf())(tmp$ret$18);
      tmp_5 = lte(get_forDate(it_1), tmp1_safe_receiver);
    }
    return yield* tmp.totalsByPlacement_39jjrf_k$(And().new_com_lightningkite_services_database_Condition_And_6mqlxl_k$(listOfNotNull([tmp_1, tmp_4, tmp_5])), $completion);
  }), 1);
}
function BalanceSheetPage$render$slambda$slambda$slambda_0($api, $from, $until) {
  return constructCallableReference(($this$async, $completion) => orPromise($completion, function *($completion) {
    var tmp = $api.get_employerAccountTransaction_bpegb9_k$();
    var tmp_0 = Aggregate_Sum_getInstance();
    // Inline function 'com.lightningkite.services.database.condition' call
    // Inline function 'com.lightningkite.services.database.path' call
    // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
    var tmp_1 = serializerOrContextual(createKType(getKClass(EmployerAccountTransaction()), arrayOf([]), false));
    var tmp$ret$2 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
    // Inline function 'kotlin.let' call
    var it = new (DataClassPathSelf())(tmp$ret$2);
    var tmp_2 = eq(get_voided_0(it), null);
    var tmp0_safe_receiver = $from;
    var tmp_3;
    if (tmp0_safe_receiver == null) {
      tmp_3 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'com.lightningkite.services.database.condition' call
      // Inline function 'com.lightningkite.services.database.path' call
      // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
      var tmp_4 = serializerOrContextual(createKType(getKClass(EmployerAccountTransaction()), arrayOf([]), false));
      var tmp$ret$9 = isInterface(tmp_4, KSerializer()) ? tmp_4 : THROW_CCE();
      // Inline function 'kotlin.let' call
      var it_0 = new (DataClassPathSelf())(tmp$ret$9);
      tmp_3 = gte(get_at(it_0), tmp0_safe_receiver);
    }
    var tmp_5 = tmp_3;
    var tmp1_safe_receiver = $until;
    var tmp_6;
    if (tmp1_safe_receiver == null) {
      tmp_6 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'com.lightningkite.services.database.condition' call
      // Inline function 'com.lightningkite.services.database.path' call
      // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
      var tmp_7 = serializerOrContextual(createKType(getKClass(EmployerAccountTransaction()), arrayOf([]), false));
      var tmp$ret$16 = isInterface(tmp_7, KSerializer()) ? tmp_7 : THROW_CCE();
      // Inline function 'kotlin.let' call
      var it_1 = new (DataClassPathSelf())(tmp$ret$16);
      tmp_6 = lt(get_at(it_1), tmp1_safe_receiver);
    }
    var tmp_8 = And().new_com_lightningkite_services_database_Condition_And_6mqlxl_k$(listOfNotNull([tmp_2, tmp_5, tmp_6]));
    // Inline function 'com.lightningkite.services.database.path' call
    // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
    var tmp_9 = serializerOrContextual(createKType(getKClass(EmployerAccountTransaction()), arrayOf([]), false));
    var tmp$ret$20 = isInterface(tmp_9, KSerializer()) ? tmp_9 : THROW_CCE();
    var tmp$ret$19 = new (DataClassPathSelf())(tmp$ret$20);
    return yield* tmp.groupAggregate_efln9_k$(new (GroupAggregateQuery())(tmp_0, tmp_8, get_employer(tmp$ret$19), (new (DataClassPathSerializer())(Companion_instance.serializer_9w0wvi_k$())).fromString_g5hge7_k$('amount.inCents')), $completion);
  }), 1);
}
function BalanceSheetPage$render$slambda$slambda$slambda_1($api, $from, $until) {
  return constructCallableReference(($this$async, $completion) => orPromise($completion, function *($completion) {
    var tmp = $api.get_grantAccountTransaction_b8gjzw_k$();
    var tmp_0 = Aggregate_Sum_getInstance();
    // Inline function 'com.lightningkite.services.database.condition' call
    // Inline function 'com.lightningkite.services.database.path' call
    // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
    var tmp_1 = serializerOrContextual(createKType(getKClass(GrantAccountTransaction()), arrayOf([]), false));
    var tmp$ret$2 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
    // Inline function 'kotlin.let' call
    var it = new (DataClassPathSelf())(tmp$ret$2);
    var tmp_2 = eq(get_voided_1(it), null);
    var tmp0_safe_receiver = $from;
    var tmp_3;
    if (tmp0_safe_receiver == null) {
      tmp_3 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'com.lightningkite.services.database.condition' call
      // Inline function 'com.lightningkite.services.database.path' call
      // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
      var tmp_4 = serializerOrContextual(createKType(getKClass(GrantAccountTransaction()), arrayOf([]), false));
      var tmp$ret$9 = isInterface(tmp_4, KSerializer()) ? tmp_4 : THROW_CCE();
      // Inline function 'kotlin.let' call
      var it_0 = new (DataClassPathSelf())(tmp$ret$9);
      tmp_3 = gte(get_at_0(it_0), tmp0_safe_receiver);
    }
    var tmp_5 = tmp_3;
    var tmp1_safe_receiver = $until;
    var tmp_6;
    if (tmp1_safe_receiver == null) {
      tmp_6 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'com.lightningkite.services.database.condition' call
      // Inline function 'com.lightningkite.services.database.path' call
      // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
      var tmp_7 = serializerOrContextual(createKType(getKClass(GrantAccountTransaction()), arrayOf([]), false));
      var tmp$ret$16 = isInterface(tmp_7, KSerializer()) ? tmp_7 : THROW_CCE();
      // Inline function 'kotlin.let' call
      var it_1 = new (DataClassPathSelf())(tmp$ret$16);
      tmp_6 = lt(get_at_0(it_1), tmp1_safe_receiver);
    }
    var tmp_8 = And().new_com_lightningkite_services_database_Condition_And_6mqlxl_k$(listOfNotNull([tmp_2, tmp_5, tmp_6]));
    // Inline function 'com.lightningkite.services.database.path' call
    // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
    var tmp_9 = serializerOrContextual(createKType(getKClass(GrantAccountTransaction()), arrayOf([]), false));
    var tmp$ret$20 = isInterface(tmp_9, KSerializer()) ? tmp_9 : THROW_CCE();
    var tmp$ret$19 = new (DataClassPathSelf())(tmp$ret$20);
    return yield* tmp.groupAggregate_efln9_k$(new (GroupAggregateQuery())(tmp_0, tmp_8, get_grant(tmp$ret$19), (new (DataClassPathSerializer())(Companion_instance_0.serializer_9w0wvi_k$())).fromString_g5hge7_k$('amount.inCents')), $completion);
  }), 1);
}
function BalanceSheetPage$render$slambda$slambda$slambda_2($api) {
  return constructCallableReference(($this$async, $completion) => orPromise($completion, function *($completion) {
    var tmp = $api.get_employer_c2djlo_k$();
    var tmp0_limit = 2147483647;
    // Inline function 'com.lightningkite.services.database.sort' call
    // Inline function 'kotlin.apply' call
    var this_0 = new (SortBuilder())();
    // Inline function 'com.lightningkite.services.database.path' call
    // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
    var tmp_0 = serializerOrContextual(createKType(getKClass(Employer()), arrayOf([]), false));
    var tmp$ret$4 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
    var it = new (DataClassPathSelf())(tmp$ret$4);
    this_0.ascending_ijynum_k$(get_name(it));
    var tmp1_orderBy = this_0.build_1k0s4u_k$();
    return yield* tmp.query_o986pg_k$(new (Query())(VOID, tmp1_orderBy, VOID, tmp0_limit), $completion);
  }), 1);
}
function BalanceSheetPage$render$slambda$slambda$slambda_3($api) {
  return constructCallableReference(($this$async, $completion) => orPromise($completion, function *($completion) {
    var tmp = $api.get_grant_is33zn_k$();
    var tmp0_limit = 2147483647;
    // Inline function 'com.lightningkite.services.database.sort' call
    // Inline function 'kotlin.apply' call
    var this_0 = new (SortBuilder())();
    // Inline function 'com.lightningkite.services.database.path' call
    // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
    var tmp_0 = serializerOrContextual(createKType(getKClass(Grant()), arrayOf([]), false));
    var tmp$ret$4 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
    var it = new (DataClassPathSelf())(tmp$ret$4);
    this_0.ascending_ijynum_k$(get_name_0(it));
    var tmp1_orderBy = this_0.build_1k0s4u_k$();
    return yield* tmp.query_o986pg_k$(new (Query())(VOID, tmp1_orderBy, VOID, tmp0_limit), $completion);
  }), 1);
}
function BalanceSheetPage$render$slambda$slambda$lambda($it) {
  return () => new (EmployerTransactionsPage())($it._id_1);
}
function BalanceSheetPage$render$slambda$slambda$lambda_0($it) {
  return () => new (GrantTransactionsPage())($it._id_1);
}
function BalanceSheetPage$render$slambda$slambda(this$0) {
  return constructCallableReference(($this$coroutineScope, $completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_currentSessionNotNull();
    var api = (yield* await_1(this_0, $completion)).api_1;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = this$0.start_1;
    var tmp0_safe_receiver = yield* await_0(this_1, $completion);
    var from = tmp0_safe_receiver == null ? null : atStartOfDayIn(tmp0_safe_receiver, get_TCG_TIME_ZONE());
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_2 = this$0.endInclusive_1;
    var tmp1_safe_receiver = yield* await_0(this_2, $completion);
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : plus(tmp1_safe_receiver, DatePeriod().new_kotlinx_datetime_DatePeriod_19p8ip_k$(VOID, VOID, 1));
    var until = tmp2_safe_receiver == null ? null : atStartOfDayIn(tmp2_safe_receiver, get_TCG_TIME_ZONE());
    var usedAsync = async($this$coroutineScope, VOID, VOID, BalanceSheetPage$render$slambda$slambda$slambda(api, this$0));
    var employerTransactionsAsync = async($this$coroutineScope, VOID, VOID, BalanceSheetPage$render$slambda$slambda$slambda_0(api, from, until));
    var grantTransactionsAsync = async($this$coroutineScope, VOID, VOID, BalanceSheetPage$render$slambda$slambda$slambda_1(api, from, until));
    var employersAsync = async($this$coroutineScope, VOID, VOID, BalanceSheetPage$render$slambda$slambda$slambda_2(api));
    var grantsAsync = async($this$coroutineScope, VOID, VOID, BalanceSheetPage$render$slambda$slambda$slambda_3(api));
    var tmp0 = (yield* usedAsync.await_4rdzbx_k$($completion)).get_values_ksazhn_k$();
    // Inline function 'kotlin.collections.fold' call
    var accumulator = new (BilledDayTotals())();
    var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var element = _iterator__ex2g4s.next_20eer_k$();
      accumulator = accumulator.plus_8jdhal_k$(element);
    }
    var used = accumulator;
    var employerTransactions = yield* employerTransactionsAsync.await_4rdzbx_k$($completion);
    var grantTransactions = yield* grantTransactionsAsync.await_4rdzbx_k$($completion);
    // Inline function 'kotlin.collections.map' call
    var this_3 = yield* employersAsync.await_4rdzbx_k$($completion);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_3, 10));
    var _iterator__ex2g4s_0 = this_3.iterator_jk1svi_k$();
    while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
      var item = _iterator__ex2g4s_0.next_20eer_k$();
      var tmp0_safe_receiver_0 = employerTransactions.get_wei43m_k$(ID__toString_impl_y5caka(item._id_1));
      var tmp1_elvis_lhs = tmp0_safe_receiver_0 == null ? null : roundToLong(tmp0_safe_receiver_0);
      var tmp = _Cents___init__impl__6gjhxu(tmp1_elvis_lhs == null ? 0n : tmp1_elvis_lhs);
      var tmp2_elvis_lhs = used.employers_1.get_wei43m_k$(new (ID())(item._id_1));
      var tmp_0 = tmp2_elvis_lhs == null ? new (PayerTotal())() : tmp2_elvis_lhs;
      var tmp$ret$7 = new (Row())(item.name_1, tmp, tmp_0, BalanceSheetPage$render$slambda$slambda$lambda(item));
      destination.add_utx5q5_k$(tmp$ret$7);
    }
    var employers = destination;
    // Inline function 'kotlin.collections.map' call
    var this_4 = yield* grantsAsync.await_4rdzbx_k$($completion);
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_4, 10));
    var _iterator__ex2g4s_1 = this_4.iterator_jk1svi_k$();
    while (_iterator__ex2g4s_1.hasNext_bitz1p_k$()) {
      var item_0 = _iterator__ex2g4s_1.next_20eer_k$();
      var tmp0_safe_receiver_1 = grantTransactions.get_wei43m_k$(ID__toString_impl_y5caka_0(item_0._id_1));
      var tmp1_elvis_lhs_0 = tmp0_safe_receiver_1 == null ? null : roundToLong(tmp0_safe_receiver_1);
      var tmp_1 = _Cents___init__impl__6gjhxu(tmp1_elvis_lhs_0 == null ? 0n : tmp1_elvis_lhs_0);
      var tmp2_elvis_lhs_0 = used.grants_1.get_wei43m_k$(new (ID_0())(item_0._id_1));
      var tmp_2 = tmp2_elvis_lhs_0 == null ? new (PayerTotal())() : tmp2_elvis_lhs_0;
      var tmp$ret$10 = new (Row())(item_0.name_1, tmp_1, tmp_2, BalanceSheetPage$render$slambda$slambda$lambda_0(item_0));
      destination_0.add_utx5q5_k$(tmp$ret$10);
    }
    var grants = destination_0;
    return to(employers, grants);
  }), 1);
}
function BalanceSheetPage$render$slambda(this$0) {
  return constructCallableReference(($this$rememberSuspending, $completion) => orPromise($completion, function *($completion) {
    return yield* coroutineScope(BalanceSheetPage$render$slambda$slambda(this$0), $completion);
  }), 1);
}
function BalanceSheetPage$render$slambda_0($data) {
  return constructCallableReference(($this$rememberSuspending, $completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = $data;
    return (yield* await_1(this_0, $completion)).first_1;
  }), 1);
}
function BalanceSheetPage$render$lambda(it) {
  return it.ledger_1();
}
function BalanceSheetPage$render$lambda_0($this$text) {
  return 'Employer';
}
function BalanceSheetPage$render$lambda_1($this$text, it) {
  return it.name_1;
}
function BalanceSheetPage$render$lambda_2($this$text, it) {
  return Cents__toString_impl_ko5hxm(it.transactions_1);
}
function BalanceSheetPage$render$lambda_3($this$text) {
  return 'Used for care';
}
function BalanceSheetPage$render$lambda_4($this$text, it) {
  return Cents__toString_impl_ko5hxm(it.used_1.amount_1);
}
function BalanceSheetPage$render$lambda_5($this$text) {
  return 'Admin charge';
}
function BalanceSheetPage$render$lambda_6($this$text, it) {
  return Cents__toString_impl_ko5hxm(it.used_1.administrativeCharge_1);
}
function BalanceSheetPage$render$slambda_1($data) {
  return constructCallableReference(($this$rememberSuspending, $completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = $data;
    return (yield* await_1(this_0, $completion)).second_1;
  }), 1);
}
function BalanceSheetPage$render$lambda_7(it) {
  return it.ledger_1();
}
function BalanceSheetPage$render$lambda_8($this$text) {
  return 'Grant';
}
function BalanceSheetPage$render$lambda_9($this$text, it) {
  return it.name_1;
}
function BalanceSheetPage$render$lambda_10($this$text, it) {
  return Cents__toString_impl_ko5hxm(it.transactions_1);
}
function BalanceSheetPage$render$lambda_11($this$text) {
  return 'Used for care';
}
function BalanceSheetPage$render$lambda_12($this$text, it) {
  return Cents__toString_impl_ko5hxm(it.used_1.amount_1);
}
function BalanceSheetPage$render$lambda_13($this$text) {
  return 'Admin charge';
}
function BalanceSheetPage$render$lambda_14($this$text, it) {
  return Cents__toString_impl_ko5hxm(it.used_1.administrativeCharge_1);
}
function BalanceSheetPage$render$lambda_15($this$shownWhen) {
  return get_current(Companion_instance_1).equals(Platform_Web_getInstance());
}
var BalanceSheetPageClass;
function BalanceSheetPage() {
  if (BalanceSheetPageClass === VOID) {
    class $ {
      constructor() {
        this.start_1 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(null);
        this.endInclusive_1 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(null);
      }
      get_title_iz32un_k$() {
        return new (Constant())(_Constant___init__impl__v45mub('Balance Sheet'));
      }
      render_w3x9d1_k$(_this__u8e3s4) {
        // Inline function 'org.thecommunitygroupinc.cares.views.components.page' call
        var this_0 = get_scrolling(_this__u8e3s4);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_1 = maxWidth(this_0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element = new (RowOrCol())(this_1.get_context_h02k06_k$());
        ensureOutermostElement(element);
        this_1.willAddChild_hz2iwc_k$(element);
        element.set_vertical_nuap32_k$(true);
        element.set_themeBase_daz04n_k$(Companion_getInstance().fromParentNonCascading_1);
        h1(element, 'Balance Sheet');
        subtext(element, 'Balances come from the ledger. Care used explains them, and runs ahead until accounting syncs.');
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_0 = new (RowOrCol())(element.get_context_h02k06_k$());
        ensureOutermostElement(element_0);
        element.willAddChild_hz2iwc_k$(element_0);
        element_0.set_vertical_nuap32_k$(false);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        // Inline function 'com.lightningkite.kiteui.views.l2.label' call
        // Inline function 'com.lightningkite.kiteui.views.l2.label' call
        var this_2 = weight(element_0, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_1 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(this_2.get_context_h02k06_k$());
        ensureOutermostElement(element_1);
        this_2.willAddChild_hz2iwc_k$(element_1);
        element_1.set_content_lzqutq_k$('From');
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        // Inline function 'com.lightningkite.kiteui.views.direct.localDateField' call
        var this_3 = themed(element_1, FieldSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_2 = new (LocalDateField())(this_3.get_context_h02k06_k$());
        ensureOutermostElement(element_2);
        this_3.willAddChild_hz2iwc_k$(element_2);
        element_2.bind_gesskf_k$(element_2.content_1, this.start_1);
        element_2.onStartup_vrxh3i_k$();
        this_3.addChild_2qpft2_k$(element_2);
        element_1.onStartup_vrxh3i_k$();
        this_2.addChild_2qpft2_k$(element_1);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        // Inline function 'com.lightningkite.kiteui.views.l2.label' call
        // Inline function 'com.lightningkite.kiteui.views.l2.label' call
        var this_4 = weight(element_0, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_3 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(this_4.get_context_h02k06_k$());
        ensureOutermostElement(element_3);
        this_4.willAddChild_hz2iwc_k$(element_3);
        element_3.set_content_lzqutq_k$('To');
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        // Inline function 'com.lightningkite.kiteui.views.direct.localDateField' call
        var this_5 = themed(element_3, FieldSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_4 = new (LocalDateField())(this_5.get_context_h02k06_k$());
        ensureOutermostElement(element_4);
        this_5.willAddChild_hz2iwc_k$(element_4);
        element_4.bind_gesskf_k$(element_4.content_1, this.endInclusive_1);
        element_4.onStartup_vrxh3i_k$();
        this_5.addChild_2qpft2_k$(element_4);
        element_3.onStartup_vrxh3i_k$();
        this_4.addChild_2qpft2_k$(element_3);
        element_0.onStartup_vrxh3i_k$();
        element.addChild_2qpft2_k$(element_0);
        var data = rememberSuspending(VOID, VOID, VOID, BalanceSheetPage$render$slambda(this));
        h2(element, 'Employers');
        var tmp = rememberSuspending(VOID, VOID, VOID, BalanceSheetPage$render$slambda_0(data));
        var tmp_0 = BalanceSheetPage$render$lambda;
        var tmp_1 = Companion_instance_2;
        var tmp_2 = BalanceSheetPage$render$lambda_0;
        var tmp_3 = tmp_1.text_y5ktm4_k$(tmp_2, 2.0, BalanceSheetPage$render$lambda_1);
        var tmp_4 = Companion_instance_2;
        var tmp_5 = ($this$text) => $this$text.invoke_r7m7el_k$(this.start_1) == null && $this$text.invoke_r7m7el_k$(this.endInclusive_1) == null ? 'Balance' : 'Net transactions';
        var tmp_6 = tmp_4.text$default_gwb2zv_k$(tmp_5, VOID, BalanceSheetPage$render$lambda_2);
        var tmp_7 = Companion_instance_2;
        var tmp_8 = BalanceSheetPage$render$lambda_3;
        var tmp_9 = tmp_7.text$default_gwb2zv_k$(tmp_8, VOID, BalanceSheetPage$render$lambda_4);
        var tmp_10 = Companion_instance_2;
        var tmp_11 = BalanceSheetPage$render$lambda_5;
        table(element, tmp, tmp_0, [tmp_3, tmp_6, tmp_9, tmp_10.text$default_gwb2zv_k$(tmp_11, VOID, BalanceSheetPage$render$lambda_6)]);
        h2(element, 'Grants');
        var tmp_12 = rememberSuspending(VOID, VOID, VOID, BalanceSheetPage$render$slambda_1(data));
        var tmp_13 = BalanceSheetPage$render$lambda_7;
        var tmp_14 = Companion_instance_2;
        var tmp_15 = BalanceSheetPage$render$lambda_8;
        var tmp_16 = tmp_14.text_y5ktm4_k$(tmp_15, 2.0, BalanceSheetPage$render$lambda_9);
        var tmp_17 = Companion_instance_2;
        var tmp_18 = ($this$text) => $this$text.invoke_r7m7el_k$(this.start_1) == null && $this$text.invoke_r7m7el_k$(this.endInclusive_1) == null ? 'Balance' : 'Net transactions';
        var tmp_19 = tmp_17.text$default_gwb2zv_k$(tmp_18, VOID, BalanceSheetPage$render$lambda_10);
        var tmp_20 = Companion_instance_2;
        var tmp_21 = BalanceSheetPage$render$lambda_11;
        var tmp_22 = tmp_20.text$default_gwb2zv_k$(tmp_21, VOID, BalanceSheetPage$render$lambda_12);
        var tmp_23 = Companion_instance_2;
        var tmp_24 = BalanceSheetPage$render$lambda_13;
        table(element, tmp_12, tmp_13, [tmp_16, tmp_19, tmp_22, tmp_23.text$default_gwb2zv_k$(tmp_24, VOID, BalanceSheetPage$render$lambda_14)]);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        var this_6 = shownWhen(element, VOID, VOID, BalanceSheetPage$render$lambda_15);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_5 = new (Space())(this_6.get_context_h02k06_k$(), 1.0);
        ensureOutermostElement(element_5);
        this_6.willAddChild_hz2iwc_k$(element_5);
        element_5.onStartup_vrxh3i_k$();
        this_6.addChild_2qpft2_k$(element_5);
        element.onStartup_vrxh3i_k$();
        this_1.addChild_2qpft2_k$(element);
        return Unit_instance;
      }
    }
    initMetadataForClass($, 'BalanceSheetPage', BalanceSheetPage, VOID, [Page()]);
    BalanceSheetPageClass = $;
  }
  return BalanceSheetPageClass;
}
//region block: exports
export {
  BalanceSheetPage as BalanceSheetPage2218um6yj4e9j,
};
//endregion

//# sourceMappingURL=BalanceSheetPage.mjs.map
